import React from "react";
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

import './ResultsDisplayToggle.scss';

interface ToggleProps {
    view: string;
    viewChanged: (viewType: string) => void;
}

export const ResultsDisplayToggle = (props: ToggleProps) => {

    return (
        <div className="display-toggle d-flex justify-content-end align-items-center text-muted">
            <span className="mr-3"> View:</span>
            <ToggleButtonGroup type="radio" name="switchView" className="btn-switch-primary float-right" value={props.view} onChange={props.viewChanged} >
                <ToggleButton variant="outline-secondary" className="fa fa-bar-chart border-class remove-radio" value="chart"><span className="sr-only"> chart</span></ToggleButton>
                <ToggleButton variant="outline-secondary" className="fa fa-table border-class remove-radio" value="table"> <span className="sr-only"> table</span></ToggleButton>
            </ToggleButtonGroup>
        </div>
    )

}